import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

interface RowProps {
  className?: string;
  bufferRowReset?: boolean;
  children?: React.ReactNode;
  dataArchived?: boolean;
  dataTestAttrs?: DataTestAttrs;
  /**
   * Rendered as a `data-amp-safe` DOM attribute. The Amplitude privacy plugin only
   * transmits `data-test-key` from nodes that opt in with `data-amp-safe={true}`;
   * set this to false when `dataTestAttrs.key` can hold customer-specified values.
   */
  dataAmpSafe?: boolean;
}

export default function Row(props: RowProps): JSX.Element {
  return (
    <div
      className={classNames('row', props.className, {bufferRowReset: props.bufferRowReset})}
      data-archived={props.dataArchived ? 'true' : undefined}
      data-amp-safe={props.dataAmpSafe}
      {...getTestProps(props.dataTestAttrs)}
    >
      {props.children}
    </div>
  );
}
